/**
 * Created by frank.law on 11/16/17.
 */
import React from 'react';
import '../../../css/login.css';
import {connect} from 'react-redux';
import PasswordField from '../formFields/PasswordField';
import FieldError from '../formFields/FieldError';
import {LocalForm} from 'react-redux-form';
import {submitPasswordChallenge, passwordOnChange, submitForgotPasswordChallenge} from '../../actions/actions';
import PropTypes from 'prop-types';
import ForgotPassword from "../ForgotPassword";


class PasswordForm extends React.Component {

    handleSubmit(formValues) {
        const { submitPasswordForm, token, challenge} = this.props;
        submitPasswordForm(formValues.password_field_1, token, challenge);
    }

    render() {

        const {title, loginLabel, username, passwordLabel, submitLabel, passwordError, passwordOnChange, forgotPasswordLabel, submitForgotPassword, token, forgotPasswordChallenge} = this.props;

        let errorField = [];
        if (passwordError) {
            errorField = (<FieldError errorText={passwordError}/>);
        }

        return (
            <div key="PasswordForm_1">
                <LocalForm model="loginForm" className="login-form" onSubmit={(formValues) => this.handleSubmit(formValues)}>
                    <h4 className="welcome">{title}</h4>
                    <p className="login-user">{loginLabel} <span title={username}>{username}</span></p>
                    <PasswordField fieldId="password_field_1" label={passwordLabel} onChangeFunc={passwordOnChange} isError={(passwordError && passwordError.length > 0)} autoFocus={true}/>
                    <ForgotPassword label={forgotPasswordLabel} onClickFunction={()=>submitForgotPassword(token, forgotPasswordChallenge)}/>
                    {errorField}
                    <button className="wdc-btn wdc-btn-primary">{submitLabel}</button>
                </LocalForm>
            </div>
        );
    }
}

PasswordForm.propTypes = {
    title: PropTypes.string,
    loginLabel: PropTypes.string,
    username: PropTypes.string,
    passwordError: PropTypes.string,
    passwordLabel: PropTypes.string,
    passwordOnChange: PropTypes.func,
    passwordFieldValue: PropTypes.string,
    forgotPasswordLabel: PropTypes.string,
    forgotPasswordChallenge: PropTypes.string,
    submitForgotPassword: PropTypes.func,
    submitLabel: PropTypes.string,
    token: PropTypes.string,
    challenge: PropTypes.string

};

const mapStateToProps = (state) => {
    return {
        passwordError: state.login.errorText,
        passwordFieldValue: state.forms.password,
        token: state.login.token,
        title: state.login.challengeResponse.title,
        loginLabel: state.login.challengeResponse.prompts.loginUser.label,
        username: state.login.challengeResponse.prompts.loginUser.value,
        passwordLabel: state.login.challengeResponse.prompts.password.label,
        passwordPlaceholder: state.login.challengeResponse.prompts.password.placeholder,
        forgotPasswordLabel: state.login.challengeResponse.prompts.forgotPassword.label,
        forgotPasswordChallenge: state.login.challengeResponse.prompts.forgotPassword.value,
        submitLabel: state.login.challengeResponse.submitLabel,
        challenge: state.login.challengeResponse.nextChallenge
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        passwordOnChange: (newValue) => {
            dispatch(passwordOnChange(newValue))
        },
        submitPasswordForm: (newValue, token, challenge) => {
            dispatch(submitPasswordChallenge(newValue, token, challenge));
        },
        submitForgotPassword:  (token, challenge) => {
            dispatch(submitForgotPasswordChallenge(token, challenge));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordForm);
